import script from "./DetailInvoiceNonPOpic.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailInvoiceNonPOpic.vue?vue&type=script&setup=true&lang=js"

import "./DetailInvoiceNonPOpic.vue?vue&type=style&index=0&id=99acac3a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99acac3a"]])

export default __exports__